import { Injectable } from '@angular/core';

@Injectable()
export class TaxonomyService {
  constructor() {}

  public nameFormatter(name) {
    if (typeof name === 'undefined' || name === '') {
      return;
    }
    name = name.trim();
    return name.charAt(0).toUpperCase() + name.substr(1).toLowerCase();
  }

  public goalNameFormatter(name) {
    if (typeof name === 'undefined' || name === '') {
      return;
    }
    return name.toLowerCase().trim();
  }

  public attributeFormatter(attribute) {
    if (typeof attribute === 'undefined' || attribute === '') {
      return;
    }
    return attribute
      .trim()
      .toLowerCase()
      .replace(/[^A-Z0-9]+/gi, '_');
  }

  getTouchpointDescriptorAttributes(touchpoints) {
    // [refactoring] - The fixed list should be removed when all touchpoints will be from taxonomy
    const result = {
      attributes: [
        'jrn_touchpoint',
        'jrn_touchpoint_propagation',
        'jrn_touchpoint_technology',
        'jrn_touchpoint_typology'
      ],
      mappedValues: {
        jrn_touchpoint: [],
        jrn_touchpoint_propagation: [],
        jrn_touchpoint_technology: [],
        jrn_touchpoint_typology: []
      }
    };

    for (const t of touchpoints) {
      // Custom
      if (typeof t.touchpointRecordId === 'undefined') {
        if (result.mappedValues['jrn_touchpoint'].map(e => e.id).indexOf(t._id) < 0) {
          result.mappedValues['jrn_touchpoint'].push({ id: t._id, name: t.name });
        }
        if (
          t.propagation !== 'undefined' &&
          result.mappedValues['jrn_touchpoint_propagation'].indexOf(t.propagation) < 0
        ) {
          result.mappedValues['jrn_touchpoint_propagation'].push(t.propagation);
        }
        if (
          t.technology !== 'undefined' &&
          result.mappedValues['jrn_touchpoint_technology'].indexOf(t.technology) < 0
        ) {
          result.mappedValues['jrn_touchpoint_technology'].push(t.technology);
        }
        if (t.typology !== 'undefined' && result.mappedValues['jrn_touchpoint_typology'].indexOf(t.typology) < 0) {
          result.mappedValues['jrn_touchpoint_typology'].push(t.typology);
        }
      } else {
        // New touchpoint
        if (typeof t.record !== 'undefined' && typeof t.record.descriptors !== 'undefined') {
          if (result.mappedValues['jrn_touchpoint'].map(e => e.id).indexOf(t._id) < 0) {
            result.mappedValues['jrn_touchpoint'].push({ id: t._id, name: t.record.name });
          }
          for (const d of t.record.descriptors) {
            if (result.attributes.indexOf(d.descriptorAttribute) < 0) {
              result.attributes.push(d.descriptorAttribute);
            }
            if (typeof result.mappedValues[d.descriptorAttribute] === 'undefined') {
              result.mappedValues[d.descriptorAttribute] = [];
            }
            if (
              d.descriptorValue !== 'undefined' &&
              result.mappedValues[d.descriptorAttribute].indexOf(d.descriptorValue) < 0
            ) {
              result.mappedValues[d.descriptorAttribute].push(d.descriptorValue);
            }
          }
        }
      }
    }
    return result;
  }

  // Sorting

  public compareByRecordName(recordA, recordB) {
    if (typeof recordA.record !== 'undefined' && typeof recordB.record !== 'undefined') {
      recordA = recordA.record;
      recordB = recordB.record;
    }

    if (recordA.name < recordB.name) {
      return -1;
    }
    if (recordA.name > recordB.name) {
      return 1;
    }
    return 0;
  }

  public compareByRecordDesc(recordA, recordB) {
    if (typeof recordA.record !== 'undefined' && typeof recordB.record !== 'undefined') {
      recordA = recordA.record;
      recordB = recordB.record;
    }

    if (typeof recordA.description === 'undefined' || recordA.description === '') {
      return 1;
    }
    if (typeof recordB.description === 'undefined' || recordB.description === '') {
      return -1;
    }

    if (recordA.description < recordB.description) {
      return -1;
    }
    if (recordA.description > recordB.description) {
      return 1;
    }
    return 0;
  }

  public compareByAction(recordA, recordB) {
    if (typeof recordA.record !== 'undefined' && typeof recordB.record !== 'undefined') {
      recordA = recordA.record;
      recordB = recordB.record;
    }

    if (
      typeof recordA.descriptorsMap === 'undefined' ||
      typeof recordA.descriptorsMap['Action'] === 'undefined' ||
      recordA.descriptorsMap['Action'].length === 0
    ) {
      return 1;
    }
    if (
      typeof recordB.descriptorsMap === 'undefined' ||
      typeof recordB.descriptorsMap['Action'] === 'undefined' ||
      recordB.descriptorsMap['Action'].length === 0
    ) {
      return 0;
    }

    const goalActionDescriptorsA = recordA.descriptorsMap['Action'].sort();
    const goalActionDescriptorsB = recordB.descriptorsMap['Action'].sort();

    if (goalActionDescriptorsA[0] < goalActionDescriptorsB[0]) {
      return -1;
    }
    if (goalActionDescriptorsA[0] > goalActionDescriptorsB[0]) {
      return 1;
    }
    return 0;
  }

  public compareByFocus(recordA, recordB) {
    if (typeof recordA.record !== 'undefined' && typeof recordB.record !== 'undefined') {
      recordA = recordA.record;
      recordB = recordB.record;
    }

    if (
      typeof recordA.descriptorsMap === 'undefined' ||
      typeof recordA.descriptorsMap['Focus'] === 'undefined' ||
      recordA.descriptorsMap['Focus'].length === 0
    ) {
      return 1;
    }
    if (
      typeof recordB.descriptorsMap === 'undefined' ||
      typeof recordB.descriptorsMap['Focus'] === 'undefined' ||
      recordB.descriptorsMap['Focus'].length === 0
    ) {
      return 0;
    }

    const goalFocusDescriptorsA = recordA.descriptorsMap['Focus'].sort();
    const goalFocusDescriptorsB = recordB.descriptorsMap['Focus'].sort();

    if (goalFocusDescriptorsA[0] < goalFocusDescriptorsB[0]) {
      return -1;
    }
    if (goalFocusDescriptorsA[0] > goalFocusDescriptorsB[0]) {
      return 1;
    }
    return 0;
  }

  public compareByDescriptorValueName(descriptorValueA, descriptorValueB) {
    if (descriptorValueA.name < descriptorValueB.name) {
      return -1;
    }
    if (descriptorValueA.name > descriptorValueB.name) {
      return 1;
    }
    return 0;
  }

  public compareByType(recordA, recordB) {
    if (typeof recordA.record !== 'undefined' && typeof recordB.record !== 'undefined') {
      recordA = recordA.record;
      recordB = recordB.record;
    }

    if (
      typeof recordA.descriptorsMap === 'undefined' ||
      typeof recordA.descriptorsMap['Type'] === 'undefined' ||
      recordA.descriptorsMap['Type'].length === 0
    ) {
      return 1;
    }
    if (
      typeof recordB.descriptorsMap === 'undefined' ||
      typeof recordB.descriptorsMap['Type'] === 'undefined' ||
      recordB.descriptorsMap['Type'].length === 0
    ) {
      return 0;
    }

    const triggerTypeDescriptorsA = recordA.descriptorsMap['Type'].sort();
    const triggerTypeDescriptorsB = recordB.descriptorsMap['Type'].sort();

    if (triggerTypeDescriptorsA[0] < triggerTypeDescriptorsB[0]) {
      return -1;
    }
    if (triggerTypeDescriptorsA[0] > triggerTypeDescriptorsB[0]) {
      return 1;
    }
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/taxonomy-service.ts